
import ShoppingCart from '../mixins/shopping-cart'

export default {
  inheritAttrs: false,
  mixins: [ShoppingCart],
  props: {
    tag: {
      type: String,
      default: 'vs-button'
    },
    product: {
      type: Object,
      default: () => {}
    },
    variantId: {
      type: [Number, String],
      default: null
    },
    message: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    variant() {
      return this.variantId || (this.product && this.product.master.id)
    }
  }
}
